export default __webpack_public_path__ + "static/pragicts-secops-services-sandboxing-61bc1cac21bf1751874d9cbc6c97dd7f.jpg";